// this is an autogenerated file from DesignSystem/EditAutomation/TriggerType/DocumentSigned/data.graphql
import { gql } from 'Data/Api'

export default gql`
query app__DesignSystem_EditAutomation_TriggerType_DocumentSigned($location_id: uuid!) {
  vaxiom_document_templates(
    where: {
      _or: [
        { organization: { level: { _neq: "location" } } }
        {
          organization: {
            _id: { _eq: $location_id }
            level: { _eq: "location" }
          }
        }
      ]
    }
    order_by: { name: asc_nulls_last }
  ) {
    vaxiom_id: id
    id: _id
    text: name
  }
}

`